export const cons = {
  newsType: [
    {
      code: '0',
      value: '资格预审',
    },
    {
      code: '1',
      value: '招标公告',
    },
    {
      code: '2',
      value: '中标候选人公示',
    },
    {
      code: '3',
      value: '结果公示',
    },
    {
      code: '4',
      value: '更正公告',
    },
  ],
  projectType: [
    {
      code: '20',
      value: '咨询项目',
    },
    {
      code: '21',
      value: '建设项目',
    },
    {
      code: '22',
      value: '招投标项目',
    },
  ],
  topType: [
    {
      code: '1',
      value: '公告',
    },
    {
      code: '2',
      value: '项目',
    },
  ],
  bool: [
    {
      code: '0',
      value: '否',
    },
    {
      code: '1',
      value: '是',
    },
  ],
};

/**
 * 根据类型查找字典
 * @param type
 * @param code
 */
export function getValueBycode(type, code) {
  const dicts = cons[type];
  const target = dicts.find((item) => item.code === code);
  return target ? target.value : `无对应类型:${code}`;
}

export const INFO = {
  fullName: '四川凯策工程咨询有限公司',
  enName: 'Sichuan Kaice Engineering Consulting Co., Ltd.',
  shortName: '凯策咨询',
  title: '四川凯策工程咨询有限公司',
  addr: '四川省成都市温江区海科路东段777号1栋2单元14楼1418号',
  point: '103.819207,30.67685',
  x: 103.819207,
  y: 30.67685,
  icpCode: '蜀ICP备2025123852号-1',
  pcCode: '510XXXXXXXXXX',
};
